import React from 'react';

const StructuredData = ({ type, data }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": type,
    ...data
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

// Spezifische Schema-Komponenten
export const OrganizationSchema = () => (
  <StructuredData
    type="Organization"
    data={{
      name: "Schmid Energieberatung",
      description: "Professionelle Energieberatung für Wärmepumpen, Solaranlagen und erneuerbare Energien",
      url: "https://schmid-energieberatung.de",
      logo: "https://schmid-energieberatung.de/logo512.png",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+49-XXX-XXXXXXX",
        contactType: "customer service",
        areaServed: "DE",
        availableLanguage: "German"
      },
      address: {
        "@type": "PostalAddress",
        addressCountry: "DE"
      },
      sameAs: [
        // Hier können Social Media Links hinzugefügt werden
      ]
    }}
  />
);

export const LocalBusinessSchema = () => (
  <StructuredData
    type="LocalBusiness"
    data={{
      name: "Schmid Energieberatung",
      description: "Energieberatung und Installation von erneuerbaren Energiesystemen",
      url: "https://schmid-energieberatung.de",
      telephone: "+49-XXX-XXXXXXX",
      address: {
        "@type": "PostalAddress",
        addressCountry: "DE"
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "48.XXXXX",
        longitude: "9.XXXXX"
      },
      openingHours: "Mo-Fr 08:00-18:00",
      priceRange: "€€",
      areaServed: "Deutschland",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Energieberatung Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Wärmepumpen Beratung",
              description: "Professionelle Beratung für Wärmepumpen"
            }
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Solaranlagen Beratung",
              description: "Beratung für Photovoltaik und Solarthermie"
            }
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Energieberatung",
              description: "Umfassende Energieberatung für Privathaushalte"
            }
          }
        ]
      }
    }}
  />
);

export const WebSiteSchema = () => (
  <StructuredData
    type="WebSite"
    data={{
      name: "Schmid Energieberatung",
      url: "https://schmid-energieberatung.de",
      description: "Professionelle Energieberatung für erneuerbare Energien",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://schmid-energieberatung.de/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }}
  />
);

export const BreadcrumbSchema = ({ items }) => (
  <StructuredData
    type="BreadcrumbList"
    data={{
      itemListElement: items.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        item: item.url
      }))
    }}
  />
);

export default StructuredData; 